import { lazy } from "react";
import { app } from "~/helpers/routes";

import { paths } from "~/router/paths";

const ImportCSVTab = lazy(() => import("~/pages/reviews/import/csv"));
const ImportAmazonTab = lazy(() => import("~/pages/reviews/import/amazon"));
const ImportAliexpressTab = lazy(
  () => import("~/pages/reviews/import/aliexpress")
);
const ManageReviewsPage = lazy(() => import("~/pages/reviews/manage"));
const ReviewsWidgetPage = lazy(() => import("~/pages/reviews/widget"));

export const routes: Array<any> = [
  {
    path: paths.app.home,
    element: app(ImportCSVTab),
  },
  {
    path: paths.reviews.importAmazon,
    element: app(ImportAmazonTab),
  },
  {
    path: paths.reviews.importAliexpress,
    element: app(ImportAliexpressTab),
  },
  {
    path: paths.reviews.manage,
    element: app(ManageReviewsPage),
  },
  {
    path: paths.reviews.widget,
    element: app(ReviewsWidgetPage),
  },
];
